// ── Backend V2 API ──────────────────────────────────────────
const BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:4000";

function getToken() {
  return localStorage.getItem("accessToken") || "";
}

function authHeaders() {
  const token = getToken();
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

// ── Public ──────────────────────────────────────────────────

export async function fetchClients() {
  const response = await fetch(`${BASE}/api/clients`);
  if (!response.ok) throw new Error("Failed to fetch clients");
  const data = await response.json();
  return data.client;
}

// ── Admin (protected) ───────────────────────────────────────

export async function insertClient(newClient) {
  const response = await fetch(`${BASE}/api/clients`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(newClient),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || "Failed to insert client");
  }
  return response.json();
}

export async function updateClient(id, updatedClient) {
  const response = await fetch(`${BASE}/api/clients/${id}`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(updatedClient),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || "Failed to update client");
  }
  return response.json();
}

export async function deleteClient(id) {
  const response = await fetch(`${BASE}/api/clients/${id}`, {
    method: "DELETE",
    headers: authHeaders(),
  });
  if (!response.ok) throw new Error("Failed to delete client");
}
